import { useQuery } from "@tanstack/react-query";

import type { ShipmentStatusEnums } from "~/shared/schemas/shipment-management-schema.ts";
import { shipmentStatusEnumsSchema } from "~/shared/schemas/shipment-management-schema.ts";
import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { getAndValidate } from "~/shared/services/api/fetch-client.ts";

const fetchShipmentStatusEnums = async (
	signal: AbortSignal,
): Promise<ShipmentStatusEnums | null> => {
	const url = apiRoutes.GETSHIPMENTSTATUSENUMS;

	const resp = await getAndValidate(url, shipmentStatusEnumsSchema, { signal });

	if (resp.success) {
		return resp.data;
	}

	console.error("Failed to fetch shipment details:", resp.error);
	return null;
};

export const useGetShipmentStatusEnums = () => {
	const { data, error, isLoading } = useQuery({
		queryKey: ["shipmentStatusEnums"],
		queryFn: ({ signal }) => fetchShipmentStatusEnums(signal),
		enabled: true,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});

	return { shipmentStatusEnums: data, error, isLoading };
};
